import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FaCheckCircle, FaExclamationTriangle, FaSpinner } from 'react-icons/fa';

export const VerifyEmail = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyToken } = useAuth();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Get token from URL query param
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
          setStatus('error');
          setMessage('No verification token found in the URL.');
          return;
        }

        // Call API to verify token
        await verifyToken(token);
        
        setStatus('success');
        setMessage('Your email has been verified successfully!');

        // After 2 seconds, navigate to home
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('error');
        
        if (error.response?.status === 410) {
          setMessage('Your verification link has expired. Please request a new one.');
        } else {
          setMessage(error.response?.data?.message || 'Failed to verify your email. Please try again.');
        }
      }
    };

    verifyEmail();
  }, [location.search, verifyToken, navigate]);

  return (
    <div className="max-w-md mx-auto my-12 p-6 bg-white rounded-lg shadow-md">
      <div className="text-center">
        {status === 'loading' && (
          <div className="space-y-4">
            <FaSpinner className="animate-spin h-12 w-12 mx-auto text-purple-600" />
            <h2 className="text-2xl font-bold text-gray-800">Verifying your email...</h2>
            <p className="text-gray-600">Please wait while we verify your email address.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <FaCheckCircle className="h-16 w-16 mx-auto text-green-500" />
            <h2 className="text-2xl font-bold text-gray-800">Email Verified!</h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-gray-600">Redirecting you to the homepage...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <FaExclamationTriangle className="h-16 w-16 mx-auto text-red-500" />
            <h2 className="text-2xl font-bold text-gray-800">Verification Failed</h2>
            <p className="text-gray-600">{message}</p>
            <div className="mt-6">
              <button
                onClick={() => navigate('/signup')}
                className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
              >
                Back to Sign Up
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail; 